import React from 'react';
import inverted_logo from '../static/footer_logo_inverted.webp';
import { NavLink, useLocation } from 'react-router-dom';
import { HOMEPAGE_ROUTE } from '../utils/consts';

const Footer = React.memo(() => {
  const location = useLocation();
  const isHomePage = location.pathname === HOMEPAGE_ROUTE;

  const logoLink = isHomePage ? (
    <a href="#banner">
      <img src={inverted_logo} alt='footer-logo' className='footer-logo' loading='lazy'/>
    </a>
  ) : (
    <NavLink to={HOMEPAGE_ROUTE}>
      <img src={inverted_logo} alt='footer-logo' className='footer-logo' loading='lazy'/>
    </NavLink>
  );

  return (
    <footer className='footer-container' id="contacts">
      <ul>
        <li>{logoLink}</li>
        <li>Адрес: г. Волгоград, ул. Самарская, здание 3в</li>
        <li>8-8442-57-12-34</li>
        <li>vok.kirpich@yandex.ru</li>
        <li style={{opacity:'0.7'}}>© 2026 «Волгоградский облицовочный кирпич»</li>
      </ul>
    </footer>
  );
});

export default React.memo(Footer);